//import InfiniteAjaxScroll from '@webcreate/infinite-ajax-scroll';

function syncMobilePaniersTotalBadge() {
  var aEl = document.getElementById('nbrItemsBm');
  var bEl = document.getElementById('nbrItemsBmq');
  var tEl = document.getElementById('nbrItemsBmTotal');
  if (!tEl) {
    return;
  }
  var a = parseInt((aEl && aEl.textContent) ? aEl.textContent : '0', 10) || 0;
  var b = parseInt((bEl && bEl.textContent) ? bEl.textContent : '0', 10) || 0;
  tEl.textContent = String(a + b);
}

function createMovieItem(movieData, vars) {

  var id = movieData.i;
  var url = vars[0];
  var addPanier = vars[1];
  var liker = vars[2];
  var cout = moneyFormat(movieData.t);
  var d = sanctificationEnc(movieData.d);
  var dtt = movieData.d;
  var hac = movieData.hac;
  var ap = movieData.ap;
  var l = sanctificationEnc(movieData.l);
  var letitre = movieData.l;
  var qmin = movieData.qmin;
  var qmax = movieData.qmax;
  //var idpanier = movieData.idp/// ompossible
  // seeItem('${url}','${id}','${ movieData.p}','${l}','${ movieData.t}','${d}')
  var df = d.substring(0, 10);

  var viewPrefix = ((typeof iasQState !== 'undefined' && iasQState) || (typeof iasQState2 !== 'undefined' && iasQState2)) ? 'Q' : 'A';
  var openFnName = ((typeof iasQState !== 'undefined' && iasQState) || (typeof iasQState2 !== 'undefined' && iasQState2)) ? 'OpenArticleq' : 'OpenArticle';

  const template1 = `<div class="col-md-4 col-sm-6 col-12 item" id="${movieData.i}">
                                <div class="single_new_arrive">
                                    <div class="sna_img">
                                        <img loading="lazy"  class="prd_img" src="${url + '' + movieData.p}" alt="product">
                                        <div class="prodcut_hovcont">
                                            <a href="${app_url + viewPrefix + '/' + id + '/' + urldecodeSanitaire(movieData.l)}" class="icon open_quickview" tabindex="0">
                                               <i class="icon-search-left"></i>
                                            </a>
                                            <a href="javascript:void(0)" class="icon" onclick="loveItem('${url}','${id}','${movieData.p}')" tabindex="0">
                                                <i class="icon-heart"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="sna_content">
                                        <a href="${app_url + viewPrefix + '/' + id + '/' + urldecodeSanitaire(movieData.l)}">
                                            <h4>${letitre.substring(0, 25)}</h4>
                                        </a>
                                        <div class="ratprice">
                                            <div class="price">
                                                <span class="org_price">${cout} </span>
                                                <span class="prev_price"></span>
                                            </div>
                                            <div class="rating">
                                                <div class="d-flex align-items-center justify-content-start">
                                                    <div class="rating_star">
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                        <span><i class="las la-star"></i></span>
                                                    </div>
                                                    <p class="rating_count"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                </div>
                                            </div>
                                             
                                        </div>
                                        <div class="product_adcart">
                                            <button class="default_btn" onclick="${openFnName}('${url}','${id}','${movieData.p}','${l}','${movieData.t}','${qmin}','${qmax}','js')"><i class="fa-solid fa-cart-plus"></i> ${addPanier} </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  `;


  const template2 = `
    <div class="single_list_product item">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="list_product_img">
                                            <div class="lp_img" onclick="SeeElPanier('${url}','${id}','${movieData.p}','${l}','${movieData.t}','${d}')">
                                                <a href="javascript:void(0)">
                                                    <img loading="lazy"  src="${url + '' + movieData.p}" alt="product">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="product_content">
                                            <a href="${app_url + viewPrefix + '/' + id + '/' + urldecodeSanitaire(movieData.l)}">
                                                <h5>${movieData.l}</h5>
                                            </a>
                                            <div class="ratprice">
                                                <div class="price">
                                                    <span class="org_price">${cout}</span>
                                                    <span class="prev_price"></span>
                                                </div>
                                                <div class="rating">
                                                    <div class="d-flex align-items-center justify-content-start">
                                                        <div class="rating_star">
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <span><i class="las la-star"></i></span>
                                                            <p class="rating_count"><i class="fa-regular fa-eye"></i> ${hac} | <i class="fa-regular fa-heart"></i> ${ap} </p>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="product_list_desc">
                                              ${dtt.substring(0, 100)}
                                            </p>
                                            <div class="product_list_btns">
                                                <button class="list_product_btn" onclick="${openFnName}('${url}','${id}','${movieData.p}','${l}','${movieData.t}','${qmin}','${qmax}')"><span class="icon"><i class="icon-cart"></i></span> ${addPanier} </button>
                                                <button class="list_product_btn wish" onclick="loveItem('${url}','${id}','${movieData.p}')"><span class="icon"><i class="icon-heart"></i></span> ${liker}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  
  
   `;


  const template3 = `

   <div class="col-md-4 col-sm-6 col-6 pb-4 item" id="${movieData.i}">
   
    
                        <div class="topr_img" onclick="openMobile('${url}','${id}','${movieData.p}','${l}','${movieData.t}','${d}','${qmin}','${qmax}')">
                            <a href="javascript:void(0)">
                                <img loading="lazy"  src="${url + '' + movieData.p}" alt="product">
                            </a>
                            <span class="tag opacity-100">${hac}</span>
                            <span class="tag opacity-50 mt-4">${ap}</span>
                        </div>
                        <div class="topr_content bg-gradient-light" onclick="window.location.href='${app_url + viewPrefix + '/' + id + '/' + urldecodeSanitaire(movieData.l)}'">
                            <a href="javascript:void(0)">
                                <h4>${movieData.l}</h4> 
                            </a>
                            <div class="price">
                                <span class="org_price">${cout}</span>
                                <span class="prev_price"></span>
                                <span class="rating_count"><i class="fa-regular fa-cart"></i> </span>
                            </div>
                            <div class="rating">
                                <div class="d-flex align-items-center justify-content-start">
                                
                                    <div class="rating_star">
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                        <span><i class="las la-star"></i></span>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
    
   
  
   
  
   `;
  ///<p class="rating_count"> <i class="fa-regular fa-eye"></i> (150)</p>
  //<span class="rating_count"><i class="fa-regular fa-heart"></i> (0)</span>

  let item = document.createElement('div');
  var ww = window.innerWidth;
  var wh = window.innerHeight;
  console.log("=======Screen======" + ww);
  if (ww > 575) {
    if (PageMode == 1) {
      item.innerHTML = template1.trim();
    }
    else {
      item.innerHTML = template2.trim();
    }

  }
  else {
    const listeBase = document.getElementById("liste_des_produits");
    listeBase.classList.add("row");
    if (PageMode == 1) {
      item.innerHTML = template3.trim();
    }
    else {
      item.innerHTML = template2.trim();
    }

  }

  return item.firstChild;
}

function nextHandler(pageIndex) {
  var key = token_api_client;
  var searchPrice = searchCout;
  var Postdata = new URLSearchParams(document.location.search);

  var req_val = ((typeof iasQState !== 'undefined' && iasQState) || (typeof iasQState2 !== 'undefined' && iasQState2)) ? 'quincallerie' : 1;

  return fetch(app_url + 'ajax/client/api.php?req=' + req_val + '&token_api_client=' + key + '&searchCout=' + searchPrice, { method: "POST", body: Postdata })
    .then(response => response.json())
    .then((data) => {
      let frag = document.createDocumentFragment();
      let itemsPerPage = MyPGCD(data.length);
      console.log(" INIT... ======== " + MyPGCD(data.length));
      if (data.length < itemsPerPage) {
        itemsPerPage = data.length;
      }
      ///
      window.titreInfo = document.getElementById("resultat_total_api");
      var titreInfoM = document.getElementById("resultat_total_apiM");
      if (data.length < itemsPerPage) {
        titreInfo.innerHTML = "<strong>" + data.length + "</strong>  " + accord(data.length, "article") + " " + accord(data.length, "trouvé") + "";
        titreInfoM.innerHTML = "<strong>" + data.length + "</strong> " + accord(data.length, "article") + " " + accord(data.length, "trouvé") + "";

        if (data.length == 0) {
          data = JSON.parse(dataVoid);
          ///return false;
          DataSource = 0;
          //console.log(itemsPerPage+"==========DATA INI LEN==============="+data.length);

        }
        else {
          DataSource = data.length;


        }
        itemsPerPage = data.length;

      }
      else {
        titreInfo.innerHTML = "<strong>" + data.length + "</strong> " + accord(data.length, "article") + " " + accord(data.length, "trouvé") + "";
        titreInfoM.innerHTML = "<strong>" + data.length + "</strong> " + accord(data.length, "article") + " " + accord(data.length, "trouvé") + "";
      }




      let totalPages = Math.ceil(data.length / itemsPerPage);
      let offset = pageIndex * itemsPerPage;
      console.log("=========================");
      ini = offset;

      // walk over the movie items for the current page and add them to the fragment
      console.log("=========================");
      for (let i = offset, len = offset + itemsPerPage; i < len; i++) {
        let movie = data[i];
        //console.log(data[i]);

        let item = createMovieItem(movie, localVars);


        frag.appendChild(item);
      }

      let hasNextPage = pageIndex < totalPages - 1;

      return this.append(Array.from(frag.childNodes))
        // indicate that there is a next page to load
        .then(() => hasNextPage);
    });


}

if (iasState || (typeof iasQState !== 'undefined' && iasQState)) {
  window.ias = new InfiniteAjaxScroll('.productlist', {
    item: '.item',
    next: nextHandler,
    pagination: false,
  });
}

if (iasState2 || (typeof iasQState2 !== 'undefined' && iasQState2)) {
  window.ias = new InfiniteAjaxScroll('.productlist', {
    item: '.item',
    next: nextHandler,
    pagination: false,
  });
}

/////////////////////////////////////////////////////////////////

function createArticleItem(url, id, p, vars) {
  const template = `<div class="product_quickview" id="xoxo">
    <div class="prodquick_wrap position-relative">
        <div class="close_quickview" id="closepop">
            <i class="las la-times"></i>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="product_view_slider">
                    <div class="single_viewslider">
                        <img id="image" loading="lazy"  src="" alt="product">
                    </div>
                   
                </div>
              
            </div>
            <div class="col-lg-6">
                <div class="product_info_wrapper">
                    <div class="product_base_info">
                        <h1 id="titre"> ${id} </h1>
                        <div class="rating d-none">
                            <div class="d-flex align-items-center">
                                <div class="rating_star">
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                    <span><i class="las la-star"></i></span>
                                </div>
                                <p class="rating_count">50 Reviews</p>
                            </div>
                        </div>
                        <div class="product_other_info d-none">
                            <p><span class="text-semibold">Availability:</span><span class="text-green">In
                                    Stock</span></p>
                            <p><span class="text-semibold">Brand:</span>Bata</p>
                            <p><span class="text-semibold">Category:</span>Clothing</p>
                            <p><span class="text-semibold">SKU:</span>BE45VGRT</p>
                        </div>
                        <div class="price mt-3 mb-3 d-flex align-items-center">
                            <span class="prev_price ms-0" id="focout"></span>
                            <span class="org_price ms-2" id="cout">$4500.00</span>
                            <div class="disc_tag ms-3">livraison offerte</div>
                        </div>
                        <div class="pd_dtails">
                            <p id="commentaire">
                                
                            </p>
                        </div>
                       
                        
                    </div>
                    <div class="product_buttons">
                        <a href="#" id="opanier" class="default_btn me-sm-3 me-2 px-2 px-lg-4"><i
                                class="icon-cart me-2"></i><span id="opaniert"> </span>  </a>
                        <a href="#" class="default_btn second px-3 px-ms-4"><i class="icon-heart me-2"></i><span id="aimert"> </span>
                            </a>
                    </div>
                    <div class="share_icons footer_icon d-flex">
                    
                    
                        <a href="javascript:void(0)" id="shareObjet" ><i class="fa-solid fa-share-nodes"></i></a>
                        <a href="#"><i class="lab la-facebook-f"></i></a>
                        <a href="#"><i class="lab la-twitter"></i></a>
                        <a href="#"><i class="lab la-instagram"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

  
  `;

  let article_detail = document.createElement('div');
  article_detail.innerHTML = template.trim();

  return article_detail.firstChild;
}



function popp_to_delete(url, article, p) {


  let item = createArticleItem(url, article, p);
  /*
    console.log("=====---////---===="+article);
    var element = document.getElementById("article_details");
      element.classList.add("active");
   */

  //var body = document.createElement("body"); 




  ///Article vue

  mySwal = function () {
    swal(arguments[0]);
    if (arguments[0].showCloseButton) {
      //closeButton = document.createElement('button');
      //closeButton.className = 'swal2-close';
      closeButton = document.getElementById("closepop");
      closeButton.onclick = function () { swal.close(); };
      closeButton.textContent = '×';
      modal = document.querySelector('.close_quickview');
      modal.appendChild(closeButton);
    }
  }


  Swal.fire({
    title: "<i>Title " + article + "</i>",
    html: item,
    confirmButtonText: "V <u>redu</u>",
    allowOutsideClick: "false",
    showCloseButton: "true",
  });


}

function closepop() {
  console.log("=====---//rwe;ob=ce//---====");
  var element = document.getElementById("xoxo");
  element.classList.remove("active");

}


async function seeItem(url, id, p, l, t, d) {
  console.log("====+++=---seeItem---==+++==" + url);

  //console.log(p+"=====---seeItem---===="+localVars);
  let item = createArticleItem(url, id, p, localVars);


  document.getElementById("pop2item").appendChild(item);
  var element = document.getElementById("xoxo");
  element.classList.add("active");

  const el = document.getElementById("closepop");
  el.addEventListener("click", closepop, false);

  const title = document.getElementById("titre");
  title.innerHTML = sanctificationDec(l);

  const commentaire = document.getElementById("commentaire");
  commentaire.innerHTML = sanctificationDec(d);

  var image = document.getElementById("image");

  image.src = url_article_path + "" + p;

  const cout = document.getElementById("cout");
  cout.innerHTML = moneyFormat(t);

  const focout = document.getElementById("focout");
  var focoutt = Math.round(t * 2);
  focout.innerHTML = moneyFormat(focoutt);

  const opaniert = document.getElementById("opaniert");
  opaniert.innerHTML = localVars[1];

  const aimert = document.getElementById("aimert");
  aimert.innerHTML = localVars[2];


  const opanier = document.getElementById("opanier");
  opanier.addEventListener("click", function () {
    OpenArticle(url, id, p, l, t, "js");
  });

  const shareObjetBtn = document.getElementById("shareObjet");
  shareObjetBtn.addEventListener("click", function () {
    var shareObjetUrl = app_url + 'A/' + id + '/' + urldecodeSanitaire(l);
    shareObjet(l, d, shareObjetUrl);
  });


  //document.getElementById('pop2item').innerHTML +=  item;

}


async function OpenArticle(url, id, p, l, t, qmin, qmax, tpage) {
  var key = token_api_client;
  let item = createArticleItem(url, id, p);

  console.log(qmax + "=====--+++++- T4--====" + l);
  var l_ = "";
  if (tpage == "js") {
    l_ = sanctificationDec(l);
  }
  else {
    l_ = l;

  }


  Swal.fire({
    title: 'Quantité de ' + l_,
    input: 'number',
    inputAttributes: {
      min: qmin,
      max: qmax,
      step: 1
    },
    inputLabel: '',
    inputPlaceholder: qmin,
    showCloseButton: true,
    confirmButtonText:
      '<i class="fa-solid fa-cart-plus"></i> Ajouter au panier',
    didOpen: () => {
      var input = Swal.getContainer().querySelector('input');

      var total_txt = "Total";
      var total_txtPU = "Prix Unitaire";
      var total_txtF = "";
      //Swal.showValidationMessage('Prix Unitaire : '+moneyFormat(1*t))
      Swal.showValidationMessage('Total : ' + moneyFormat(qmin * t))
      var estimation = "XXXX";
      var globalRegex1 = new RegExp('.', 'g');
      var globalRegex2 = new RegExp(',', 'g');
      var numberRegex = /^\d+$/;

      Swal.getPopup().querySelector('input').value = qmin;
      ///
      input.addEventListener('blur', (e) => {
        //Swal.fire(`Entered amount`)
        //console.log('===>'+Swal.getPopup().querySelector('input').value);
        if (Swal.getPopup().querySelector('input').value) {
          var QteInput = parseInt(Swal.getPopup().querySelector('input').value);
          //console.log(qmin+"=====BLUR===="+QteInput);

          if (QteInput == "" || QteInput < qmin || QteInput > qmin || isNaN(parseFloat(QteInput))) {
            //QteInput = qmin;
            //Swal.getPopup().querySelector('input').value = "";
            //total_txtF = total_txtPU;
            //estimation = " :  "+moneyFormat(1*t);
            //Swal.getConfirmButton().setAttribute('disabled','');
            total_txtF = "";
            estimation = "";
          }
          else {
            Swal.getConfirmButton().removeAttribute('disabled');
            total_txtF = "";
            estimation = "";
          }

          //Swal.showValidationMessage(total_txtF+''+estimation)
        } else {
          //console.log('- The element does not exists in the page.');
        }

      })
      ////
      input.addEventListener('keyup', (e) => {
        if (Swal.getPopup().querySelector('input').value) {
          var QteInput = parseInt(Swal.getPopup().querySelector('input').value);
          //Swal.fire(`Entered amount ${QteInput}`)
          //console.log(qmin+"=====KEYUP===="+QteInput);

          if (QteInput == "" || isNaN(parseFloat(QteInput)) || QteInput == undefined) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }
          else if (!numberRegex.test(QteInput)) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }
          else if (globalRegex2.test(QteInput)) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }

          else {
            if (QteInput < qmin) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte minimum est " + qmin;
              estimation = "";
            }
            else if (QteInput > qmax) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte maximum est " + qmax;
              estimation = "";
            }
            else {
              Swal.getConfirmButton().removeAttribute('disabled');
              total_txtF = total_txt;
              estimation = " : " + moneyFormat(QteInput * t)
            }

          }


          Swal.showValidationMessage(total_txtF + '' + estimation)
          //var valueT = e.detail.value;
          //Swal.getConfirmButton().disabled = QteInput < qmin;

        } else {
          //console.log('222The does not exists in the page.');
          Swal.getConfirmButton().setAttribute('disabled', '');
          Swal.getPopup().querySelector('input').value = "";
        }


      })

      input.addEventListener('change', (e) => {
        if (Swal.getPopup().querySelector('input').value) {
          var QteInput = parseInt(Swal.getPopup().querySelector('input').value);
          //Swal.fire(`Entered amount`)
          //console.log(qmin+"=====CHANGE===="+QteInput);

          if (QteInput == "" || isNaN(parseFloat(QteInput))) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }
          else {
            if (QteInput < qmin) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte minimum est " + qmin;
              estimation = "";
            }
            else if (QteInput > qmax) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte maximum est " + qmax;
              estimation = "";
            }
            else {
              Swal.getConfirmButton().removeAttribute('disabled');
              total_txtF = total_txt;
              var QteInputC = Swal.getPopup().querySelector('input').value
              estimation = " : " + moneyFormat(QteInputC * t)
            }

          }


          Swal.showValidationMessage(total_txtF + '' + estimation)
          //var valueT = e.detail.value;
          //Swal.getConfirmButton().disabled = QteInput < qmin;

        } else {
          //console.log('333 The does not exists in the page.');
          Swal.getPopup().querySelector('input').value = "";
        }


      })



    },
    showLoaderOnConfirm: true,
    preConfirm: (val) => {
      //const value = Swal.getContainer().querySelector('input').value;
      //return value < 0 ? Swal.showValidationMessage(localVars[3]) : value;

      window.tempQte = val;
      return fetch(app_url + `ajax/client/api.php?req=2&token_api_client=${key}&id=${id}&qte=${val}`)
        .then(response => {
          if (!response.ok) {
            ///statusText
            throw new Error(response.status)
          }
          return response.json()
        })
        .catch(error => {
          errorPage();
          //Swal.showValidationMessage(`Erreur : ${error}`)
        })
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    //console.log("====undef==="+result);

    if (result.value) {

      if (result.value.r == "noclient") {
        console.log(result.value.r);
        window.location.replace(loginPage);
        return false;

      }

      if (result.value.r == "noarticle") {
        console.log(result.value.r);
        Swal.fire(
          'Article introuvable',
          'Cet article a peut-être été supprimé',
          'error'
        )
        return false;

      }
      console.log(result.value.contenu.nbr);

      if (result.isConfirmed && result.value.r == "ok") {
        const boxWrapper = document.getElementById("panier_visuel_web");
        const boxWrapperm = document.getElementById("panier_visuel_webm");

        const box = document.createElement("div");
        const boxm = document.createElement("div");

        const child = document.getElementById("paniervide");
        const childm = document.getElementById("paniervidem");


        if (result.value.contenu.nbr == 1) {
          child.remove();
          childm.remove();
        }
        else {

        }

        idcp = result.value.contenu.idcp;

        p_p3x952 = result.value.contenu.panier;

        box.innerHTML = createPanierItem(idcp, IntNotNull(tempQte), p, l, t, app_url, url_article_path);
        boxm.innerHTML = createPanierItemm(idcp, IntNotNull(tempQte), p, l, t, app_url, url_article_path);
        //box.style.backgroundColor = "orange";
        //box.classList.add("box");
        boxWrapper.appendChild(box);
        boxWrapperm.appendChild(boxm);
        //WEB
        const nbrItemsT = document.getElementById("nbrItemsT");
        nbrItemsT.innerHTML = "" + result.value.contenu.nbr + " " + accordTxt(localVars[4], result.value.contenu.nbr);


        const nbrItemsB = document.getElementById("nbrItemsB");
        nbrItemsB.innerHTML = result.value.contenu.nbr;

        const CoutTotalFacturePanier = document.getElementById("CoutTotalFacturePanier");
        CoutTotalFacturePanier.innerHTML = moneyFormat(result.value.contenu.xof);
        //MOBILE 

        const nbrItemsTm = document.getElementById("nbrItemsTm");
        nbrItemsTm.innerHTML = "" + result.value.contenu.nbr + " " + accordTxt(localVars[4], result.value.contenu.nbr);

        const nbrItemsBm = document.getElementById("nbrItemsBm");
        nbrItemsBm.innerHTML = result.value.contenu.nbr;
        syncMobilePaniersTotalBadge();


        const CoutTotalFacturePanierm = document.getElementById("CoutTotalFacturePanierm");
        CoutTotalFacturePanierm.innerHTML = moneyFormat(result.value.contenu.xof);

        setLocalVars("p3x952", enc(String(result.value.contenu.xof)));


        Swal.fire(
          'Article ajouté',
          'Cet article a été ajouté à votre panier',
          'success'
        )



      }

    }
    else {

    }

  }).catch((e) => {
    errorPage();
    // This is where you handle errors.
  })

  //if (val) {
  /////

  /////

  //Swal.fire(`Entered email: ${qte}`)
  //}

}

async function OpenArticleq(url, id, p, l, t, qmin, qmax, tpage) {
  var key = token_api_client;
  let item = createArticleItem(url, id, p);

  console.log(qmax + "=====--+++++- T4--====" + l);
  var l_ = "";
  if (tpage == "js") {
    l_ = sanctificationDec(l);
  }
  else {
    l_ = l;

  }


  Swal.fire({
    title: 'Quantité de ' + l_,
    input: 'number',
    inputAttributes: {
      min: qmin,
      max: qmax,
      step: 1
    },
    inputLabel: '',
    inputPlaceholder: qmin,
    showCloseButton: true,
    confirmButtonText:
      '<i class="fa-solid fa-cart-plus"></i> Ajouter au panier',
    didOpen: () => {
      var input = Swal.getContainer().querySelector('input');

      var total_txt = "Total";
      var total_txtPU = "Prix Unitaire";
      var total_txtF = "";
      //Swal.showValidationMessage('Prix Unitaire : '+moneyFormat(1*t))
      Swal.showValidationMessage('Total : ' + moneyFormat(qmin * t))
      var estimation = "XXXX";
      var globalRegex1 = new RegExp('.', 'g');
      var globalRegex2 = new RegExp(',', 'g');
      var numberRegex = /^\d+$/;

      Swal.getPopup().querySelector('input').value = qmin;
      ///
      input.addEventListener('blur', (e) => {
        //Swal.fire(`Entered amount`)
        //console.log('===>'+Swal.getPopup().querySelector('input').value);
        if (Swal.getPopup().querySelector('input').value) {
          var QteInput = parseInt(Swal.getPopup().querySelector('input').value);
          //console.log(qmin+"=====BLUR===="+QteInput);

          if (QteInput == "" || QteInput < qmin || QteInput > qmin || isNaN(parseFloat(QteInput))) {
            //QteInput = qmin;
            //Swal.getPopup().querySelector('input').value = "";
            //total_txtF = total_txtPU;
            //estimation = " :  "+moneyFormat(1*t);
            //Swal.getConfirmButton().setAttribute('disabled','');
            total_txtF = "";
            estimation = "";
          }
          else {
            Swal.getConfirmButton().removeAttribute('disabled');
            total_txtF = "";
            estimation = "";
          }

          //Swal.showValidationMessage(total_txtF+''+estimation)
        } else {
          //console.log('- The element does not exists in the page.');
        }

      })
      ////
      input.addEventListener('keyup', (e) => {
        if (Swal.getPopup().querySelector('input').value) {
          var QteInput = parseInt(Swal.getPopup().querySelector('input').value);
          //Swal.fire(`Entered amount ${QteInput}`)
          //console.log(qmin+"=====KEYUP===="+QteInput);

          if (QteInput == "" || isNaN(parseFloat(QteInput)) || QteInput == undefined) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }
          else if (!numberRegex.test(QteInput)) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }
          else if (globalRegex2.test(QteInput)) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }

          else {
            if (QteInput < qmin) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte minimum est " + qmin;
              estimation = "";
            }
            else if (QteInput > qmax) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte maximum est " + qmax;
              estimation = "";
            }
            else {
              Swal.getConfirmButton().removeAttribute('disabled');
              total_txtF = total_txt;
              estimation = " : " + moneyFormat(QteInput * t)
            }

          }


          Swal.showValidationMessage(total_txtF + '' + estimation)
          //var valueT = e.detail.value;
          //Swal.getConfirmButton().disabled = QteInput < qmin;

        } else {
          //console.log('222The does not exists in the page.');
          Swal.getConfirmButton().setAttribute('disabled', '');
          Swal.getPopup().querySelector('input').value = "";
        }


      })

      input.addEventListener('change', (e) => {
        if (Swal.getPopup().querySelector('input').value) {
          var QteInput = parseInt(Swal.getPopup().querySelector('input').value);
          //Swal.fire(`Entered amount`)
          //console.log(qmin+"=====CHANGE===="+QteInput);

          if (QteInput == "" || isNaN(parseFloat(QteInput))) {
            Swal.getConfirmButton().setAttribute('disabled', '');
            //QteInput = 99;
            total_txtF = "La Qte minimum est " + qmin;
            estimation = "";
          }
          else {
            if (QteInput < qmin) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte minimum est " + qmin;
              estimation = "";
            }
            else if (QteInput > qmax) {
              Swal.getConfirmButton().setAttribute('disabled', '');
              total_txtF = "*La Qte maximum est " + qmax;
              estimation = "";
            }
            else {
              Swal.getConfirmButton().removeAttribute('disabled');
              total_txtF = total_txt;
              var QteInputC = Swal.getPopup().querySelector('input').value
              estimation = " : " + moneyFormat(QteInputC * t)
            }

          }


          Swal.showValidationMessage(total_txtF + '' + estimation)
          //var valueT = e.detail.value;
          //Swal.getConfirmButton().disabled = QteInput < qmin;

        } else {
          //console.log('333 The does not exists in the page.');
          Swal.getPopup().querySelector('input').value = "";
        }


      })



    },
    showLoaderOnConfirm: true,
    preConfirm: (val) => {
      //const value = Swal.getContainer().querySelector('input').value;
      //return value < 0 ? Swal.showValidationMessage(localVars[3]) : value;

      window.tempQte = val;
      return fetch(app_url + `ajax/client/api.php?req=addpanierquincaillerie&token_api_client=${key}&id=${id}&qte=${val}`)
        .then(response => {
          if (!response.ok) {
            ///statusText
            throw new Error(response.status)
          }
          return response.json()
        })
        .catch(error => {
          errorPage();
          //Swal.showValidationMessage(`Erreur : ${error}`)
        })
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    //console.log("====undef==="+result);

    if (result.value) {

      if (result.value.r == "noclient") {
        console.log(result.value.r);
        window.location.replace(loginPage);
        return false;

      }

      if (result.value.r == "noarticle") {
        console.log(result.value.r);
        Swal.fire(
          'Article introuvable',
          'Cet article a peut-être été supprimé',
          'error'
        )
        return false;

      }
      console.log(result.value.contenu.nbr);

      if (result.isConfirmed && result.value.r == "ok") {
        const boxWrapper = document.getElementById("panier_visuel_webq");
        const boxWrapperm = document.getElementById("panier_visuel_webmq");

        const box = document.createElement("div");
        const boxm = document.createElement("div");

        const child = document.getElementById("paniervideq");
        const childm = document.getElementById("paniervidemq");


        if (result.value.contenu.nbr == 1) {
          if (child) child.remove();
          if (childm) childm.remove();
        }
        else {

        }

        idcp = result.value.contenu.idcp;

        p_p3x952 = result.value.contenu.panier;

        box.innerHTML = createPanierItemq(idcp, IntNotNull(tempQte), p, l, t, app_url, url_articleq_path);
        boxm.innerHTML = createPanierItemmq(idcp, IntNotNull(tempQte), p, l, t, app_url, url_articleq_path);
        //box.style.backgroundColor = "orange";
        //box.classList.add("box");
        if (boxWrapper) boxWrapper.appendChild(box);
        if (boxWrapperm) boxWrapperm.appendChild(boxm);
        //WEB
        const nbrItemsT = document.getElementById("nbrItemsTq");
        if (nbrItemsT) nbrItemsT.innerHTML = "" + result.value.contenu.nbr + " " + accordTxt(localVars[4], result.value.contenu.nbr);


        const nbrItemsB = document.getElementById("nbrItemsBq");
        if (nbrItemsB) nbrItemsB.innerHTML = result.value.contenu.nbr;

        const nbrItemsTm = document.getElementById("nbrItemsTmq");
        if (nbrItemsTm) nbrItemsTm.innerHTML = "" + result.value.contenu.nbr + " " + accordTxt(localVars[4], result.value.contenu.nbr);

        const nbrItemsBm = document.getElementById("nbrItemsBmq");
        if (nbrItemsBm) nbrItemsBm.innerHTML = result.value.contenu.nbr;
        syncMobilePaniersTotalBadge();

        syncPanierQuincaillerieTotals(result.value.contenu.xof);

        Swal.fire(
          'Article ajouté',
          'Cet article a été ajouté à votre panier quincaillerie',
          'success'
        )



      }

    }
    else {

    }

  }).catch((e) => {
    errorPage();
    // This is where you handle errors.
  })

}

async function loveItem(url, id, p, l, txt) {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  var key = token_api_client;
  fetch(app_url + `ajax/client/api.php?req=4&token_api_client=${key}&id=${id}`)
    .then((response) => {
      if (!response.ok) { // Before parsing (i.e. decoding) the JSON data,
        // check for any errors.
        // In case of an error, throw.
        throw new Error("Something went wrong!");
      }

      return response.json(); // Parse the JSON data.
    })
    .then((data) => {
      // This is where you handle what to do with the response.
      //alert(data.r); // Will alert: 42
      if (data.r == "oui") {


        Toast.fire({
          icon: 'success',
          title: 'J\'aime'
        })


      }
      else {
        Toast.fire({
          icon: 'success',
          title: 'J\'aime déjà'
        })

      }
    })
    .catch((e) => {
      errorPage();
      // This is where you handle errors.
    });




}

async function loveItemq(url, id, p, l, txt) {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  var key = token_api_client;
  fetch(app_url + `ajax/client/api.php?req=loveq&token_api_client=${key}&id=${id}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Something went wrong!");
      }
      return response.json();
    })
    .then((data) => {
      if (data.r == "oui") {
        Toast.fire({
          icon: 'success',
          title: 'J\'aime'
        })
      }
      else {
        Toast.fire({
          icon: 'success',
          title: 'J\'aime déjà'
        })
      }
    })
    .catch((e) => {
      errorPage();
    });
}


function moneyFormat(val) {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(val);

}


function numberFormat(val) {
  return new Intl.NumberFormat('fr-FR', { maximumSignificantDigits: 3 }).format(val);
}




function createPanierItem(id, qte, p, l, t, app_url, url_article_path) {
  //let li = document.createElement('p');
  const textContent = `<a href="#" class="single_cartdrop mb-3" id="${id}">
                                    <span class="remove_cart" onclick="RemovElPanier('${id}','${l}','${qte}','${t}')"><i class="las la-times"></i></span>
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="${url_article_path + "" + p}" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link" onclick="SeeElPanier('${app_url}','${id}','${p}','${sanctificationEnc(l)}','${t}','${qte}')">
                                            ${sanctificationDec(l)}
                                        </h5>
                                        <p class="mb-0 text_xs text_p">x${qte} <span class="ms-2">${t}</span></p>
                                    </div>
                                </a>`;
  return textContent;
}

function createPanierItemm(id, qte, p, l, t, app_url, url_article_path) {
  //let li = document.createElement('p');
  const textContent = `<a href="#" class="single_cartdrop mb-3" id="${id}_m">
                                    <span class="remove_cart" onclick="RemovElPanier('${id}','${l}','${qte}','${t}')"><i class="las la-times"></i></span>
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="${url_article_path + "" + p}" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link" onclick="SeeElPanier('${app_url}','${id}','${p}','${sanctificationEnc(l)}','${t}','${qte}')">
                                            ${sanctificationDec(l)}
                                        </h5>
                                        <p class="mb-0 text_xs text_p">x${qte} <span class="ms-2">${t}</span></p>
                                    </div>
                                </a>`;
  return textContent;
}

function createPanierItemq(id, qte, p, l, t, app_url, url_article_path) {
  //let li = document.createElement('p');
  const textContent = `<a href="#" class="single_cartdrop mb-3" id="${id}">
                                    <span class="remove_cart" onclick="RemovElPanierq('${id}','${l}','${qte}','${t}')"><i class="las la-times"></i></span>
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="${url_article_path + "" + p}" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link" onclick="SeeElPanierq('${app_url}','${id}','${p}','${sanctificationEnc(l)}','${t}','${qte}')">
                                            ${sanctificationDec(l)}
                                        </h5>
                                        <p class="mb-0 text_xs text_p">x${qte} <span class="ms-2">${t}</span></p>
                                    </div>
                                </a>`;
  return textContent;
}

function createPanierItemmq(id, qte, p, l, t, app_url, url_article_path) {
  //let li = document.createElement('p');
  const textContent = `<a href="#" class="single_cartdrop mb-3" id="${id}_m">
                                    <span class="remove_cart" onclick="RemovElPanierq('${id}','${l}','${qte}','${t}')"><i class="las la-times"></i></span>
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="${url_article_path + "" + p}" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link" onclick="SeeElPanierq('${app_url}','${id}','${p}','${sanctificationEnc(l)}','${t}','${qte}')">
                                            ${sanctificationDec(l)}
                                        </h5>
                                        <p class="mb-0 text_xs text_p">x${qte} <span class="ms-2">${t}</span></p>
                                    </div>
                                </a>`;
  return textContent;
}



function RemovElPanier(id, l, qte, t) {
  var key = token_api_client;
  var textAccord = "";
  var l = sanctificationDec(l);
  var total = qte * t;
  Swal.fire({
    title: 'Etes-vous sur de retirer ' + l + ' ?',
    text: "Estimation du cout : " + qte + " x " + moneyFormat(t) + " = " + moneyFormat(total) + " ",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'non',
    confirmButtonText: 'oui, je suis sur !',
    showLoaderOnConfirm: true,
    preConfirm: () => {
      return fetch(app_url + `ajax/client/api.php?req=3&token_api_client=${key}&id=${id}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }
          return response.json()
        })
        .catch(error => {
          Swal.showValidationMessage(
            `Request failed: ${error}`
          )
        })
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      document.getElementById(id).remove();
      document.getElementById(id + "_m").remove();

      const CoutTotalFacturePanier = document.getElementById("CoutTotalFacturePanier");
      CoutTotalFacturePanier.innerHTML = moneyFormat(result.value.xof);

      const CoutTotalFacturePanierm = document.getElementById("CoutTotalFacturePanierm");
      CoutTotalFacturePanierm.innerHTML = moneyFormat(result.value.xof);


      const nbrItemsT = document.getElementById("nbrItemsT");
      nbrItemsT.innerHTML = "" + result.value.nbr + " " + accordTxt(localVars[4], result.value.nbr);

      const nbrItemsTm = document.getElementById("nbrItemsTm");
      nbrItemsTm.innerHTML = "" + result.value.nbr + " " + accordTxt(localVars[4], result.value.nbr);

      const nbrItemsB = document.getElementById("nbrItemsB");
      nbrItemsB.innerHTML = result.value.nbr;

      const nbrItemsBm = document.getElementById("nbrItemsBm");
      nbrItemsBm.innerHTML = result.value.nbr;
      syncMobilePaniersTotalBadge();



      setLocalVars("p3x952", enc(String(result.value.xof)));

      if (result.value.nbr == 0) {
        const panierlist = document.getElementById("panier_visuel_web");
        //const box = document.createElement("br");
        panierlist.innerHTML += createPanierVide("web");

        // panierlist.appendTo(box);

        const panierlistm = document.getElementById("panier_visuel_webm");
        //const box = document.createElement("br");
        panierlistm.innerHTML += createPanierVide("mobile");

      }
      else {

      }

      Swal.fire(
        'Article Retiré !',
        qte + ' ' + l + ' ' + TexteDeleteOk(qte) + ' de votre panier',
        'success'
      ).then(refeshPage())
    }
  })
  //alert("remove"+id)


}

function SeeElPanier(id) {
  console.log(id);
  //alert("See"+id)
}

function SeeElPanierq(id) {
  console.log(id);
}

function RemovElPanierq(id, l, qte, t) {
  var key = token_api_client;
  var textAccord = "";
  var l = sanctificationDec(l);
  var total = qte * t;
  Swal.fire({
    title: 'Etes-vous sur de retirer ' + l + ' ?',
    text: "Estimation du cout : " + qte + " x " + moneyFormat(t) + " = " + moneyFormat(total) + " ",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'non',
    confirmButtonText: 'oui, je suis sur !',
    showLoaderOnConfirm: true,
    preConfirm: () => {
      return fetch(app_url + `ajax/client/api.php?req=removq&token_api_client=${key}&id=${id}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }
          return response.json()
        })
        .catch(error => {
          Swal.showValidationMessage(
            `Request failed: ${error}`
          )
        })
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      if (document.getElementById(id)) {
        document.getElementById(id).remove();
      }
      if (document.getElementById(id + "_m")) {
        document.getElementById(id + "_m").remove();
      }
      if (document.getElementById(id + "_sc")) {
        document.getElementById(id + "_sc").remove();
      }

      syncPanierQuincaillerieTotals(result.value.xof);

      const nbrItemsT = document.getElementById("nbrItemsTq");
      if (nbrItemsT) nbrItemsT.innerHTML = "" + result.value.nbr + " " + accordTxt(localVars[4], result.value.nbr);

      const nbrItemsTm = document.getElementById("nbrItemsTmq");
      if (nbrItemsTm) nbrItemsTm.innerHTML = "" + result.value.nbr + " " + accordTxt(localVars[4], result.value.nbr);

      const nbrItemsB = document.getElementById("nbrItemsBq");
      if (nbrItemsB) nbrItemsB.innerHTML = result.value.nbr;

      const nbrItemsBm = document.getElementById("nbrItemsBmq");
      if (nbrItemsBm) nbrItemsBm.innerHTML = result.value.nbr;
      syncMobilePaniersTotalBadge();

      if (result.value.nbr == 0) {
        const panierlist = document.getElementById("panier_visuel_webq");
        if (panierlist) panierlist.innerHTML += createPanierVideq("web");

        const panierlistm = document.getElementById("panier_visuel_webmq");
        if (panierlistm) panierlistm.innerHTML += createPanierVideq("mobile");
      }

      console.log("retrait panier quincaillerie " + panier_liste);

      Swal.fire(
        'Article Retiré !',
        qte + ' ' + l + ' ' + TexteDeleteOk(qte) + ' de votre panier quincaillerie',
        'success'
      ).then(() => {
        if (typeof panier_liste !== 'undefined' && panier_liste && result.value.nbr == 0) {
          refeshPage();
        }
      })
    }
  })
}

function getSousTotalPanierq() {
  if (typeof window.p3x952q !== 'undefined' && window.p3x952q !== '') {
    return parseInt(window.p3x952q, 10) || 0;
  }
  if (typeof getLocalVars === 'function' && typeof dec === 'function') {
    return parseInt(dec(getLocalVars('p3x952q')), 10) || 0;
  }
  return 0;
}

function syncPanierQuincaillerieTotals(sousTotal) {
  var sousTotalNum = parseInt(sousTotal, 10) || 0;
  var coutLiv = parseInt(window.livrCout, 10) || 0;
  var total = sousTotalNum + coutLiv;

  window.p3x952q = String(sousTotalNum);
  window.coutFinal = total;

  if (typeof setLocalVars === 'function' && typeof enc === 'function') {
    setLocalVars('p3x952q', enc(String(sousTotalNum)));
  }

  var formattedSous = moneyFormat(sousTotalNum);
  var formattedTotal = moneyFormat(total);

  ['CoutTotalFacturePanierq', 'CoutTotalFacturePaniermq'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = formattedSous;
  });

  var elSous = document.getElementById('sousTotalPanierq');
  if (elSous) elSous.textContent = formattedSous;

  var elTotal = document.getElementById('coutlivraisonqT');
  if (elTotal) elTotal.textContent = formattedTotal;
}

function updateLivraisonQuincaillerieUI(coutLiv, total, commune, idl) {
  window.livrID = idl || '';
  window.livrCout = String(coutLiv || 0);
  window.livrCommune = commune || '';
  window.coutFinal = total;

  var elCout = document.getElementById('coutlivraisonq');
  if (elCout) elCout.textContent = moneyFormat(coutLiv);

  var elTotal = document.getElementById('coutlivraisonqT');
  if (elTotal) elTotal.textContent = moneyFormat(total);
}

function setPointLivraisonq(communeId) {
  if (!communeId || typeof app_url === 'undefined' || typeof token_api_client === 'undefined') {
    return;
  }

  fetch(app_url + 'ajax/client/api.php?req=pointdelivraisonq&token_api_client=' + token_api_client + '&id=' + encodeURIComponent(communeId))
    .then(function (response) {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .then(function (data) {
      if (data.r === 'ok') {
        var coutLiv = parseInt(data.cout, 10) || 0;
        var sousTotal = getSousTotalPanierq();
        updateLivraisonQuincaillerieUI(coutLiv, sousTotal + coutLiv, data.commune, data.idl);
        syncPanierQuincaillerieTotals(sousTotal);
      } else {
        Swal.fire('Erreur', 'Commune de livraison introuvable.', 'error');
      }
    })
    .catch(function (error) {
      console.error(error);
      errorPage();
    });
}

function initCommuneLivraisonq() {
  if (typeof jQuery === 'undefined') {
    return;
  }
  jQuery(document).off('change.communeLivraisonq', '#communeLivraison');
  jQuery(document).on('change.communeLivraisonq', '#communeLivraison', function () {
    var communeId = jQuery(this).val();
    if (!communeId) {
      updateLivraisonQuincaillerieUI(0, getSousTotalPanierq(), '', '');
      return;
    }
    setPointLivraisonq(communeId);
  });
}

if (typeof jQuery !== 'undefined') {
  jQuery(initCommuneLivraisonq);
} else {
  document.addEventListener('DOMContentLoaded', initCommuneLivraisonq);
}


function accordTxt(txt, nbr) {
  if (nbr > 1) {
    txtf = txt + "s";
  }
  else {
    txtf = txt;
  }
  return txtf;
}

function TexteDeleteOk(qte) {
  var texteFinal = "";
  if (qte > 1) {
    texteFinal = "on été rétirés";
  }
  else {
    texteFinal = "a été rétiré";
  }

  return texteFinal;

}

function IntNotNull(nbr) {
  //console.log("=========int val : "+nbr.length+"==========");
  var str = 1;
  if (nbr == 0 || nbr.length < 1) {
    str = 1;
  }
  else {
    str = nbr;
  }

  return str;


}



function createPanierVide($ecran) {
  var lv5 = localVars[5];
  var lv6 = localVars[6];
  if ($ecran == "web") {
    var textContent = `<a href="#" class="single_cartdrop" id="paniervide">
                                  
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="../article/panier.jpg" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link">
                                           ${lv5}
                                        </h5>
                                        <p class="mb-0 text_xs text_p"> ${lv6}  <span class="ms-2"></span></p>
                                    </div>
                                </a>
                                `;
  }
  else {
    var textContent = `<a href="#" class="single_cartdrop" id="paniervidem">
                                  
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="../article/panier.jpg" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link">
                                           ${lv5}
                                        </h5>
                                        <p class="mb-0 text_xs text_p"> ${lv6} <span class="ms-2"></span></p>
                                    </div>
                                </a>
                                `;

  }

  return textContent;

}

function createPanierVideq($ecran) {
  var lv5 = localVars[5];
  var lv6 = localVars[6];
  if ($ecran == "web") {
    var textContent = `<a href="#" class="single_cartdrop" id="paniervideq">
                                  
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="../article/panier.jpg" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link">
                                           ${lv5}
                                        </h5>
                                        <p class="mb-0 text_xs text_p"> ${lv6}  <span class="ms-2"></span></p>
                                    </div>
                                </a>
                                `;
  }
  else {
    var textContent = `<a href="#" class="single_cartdrop" id="paniervidemq">
                                  
                                    <div class="cartdrop_img">
                                        <img loading="lazy"  src="../article/panier.jpg" alt="product">
                                    </div>
                                    <div class="cartdrop_cont">
                                        <h5 class="text_lg mb-0 default_link">
                                           ${lv5}
                                        </h5>
                                        <p class="mb-0 text_xs text_p"> ${lv6} <span class="ms-2"></span></p>
                                    </div>
                                </a>
                                `;

  }

  return textContent;

}


function filtre_par_cout() {
  //window.searchCout = "plus";
  var x = document.getElementById("filtre_par_cout");
  //x.value = x.value.toUpperCase();
  if (searchVille.length > 2) {
    const searchVilleTreat = searchVille.slice(searchVille.indexOf('r_') + 2);
    window.location.href = searchCoutPage + "&searchCoutPage=" + x.value + "&searchVille=" + searchVilleTreat;

  }
  else {

    window.location.href = searchCoutPage + "&searchCoutPage=" + x.value;

  }
  //alert(x.value);

}

function filtre_par_cout_mobile_________________________________________() {
  //window.searchCout = "plus";
  var x = document.getElementById("filtre_par_cout_mobile");
  //x.value = x.value.toUpperCase();
  window.location.href = searchCoutPage + "&searchCoutPage=" + x.value;
  //alert(x.value);

}


function rechercher_par_type____________________________() {
  console.log("rechercher_par_type");
  Swal.fire({
    title: 'Login Form',
    html: `NPmm <input type="text" id="login" class="swal2-input" placeholder="Username">
  Prenonn <input type="password" id="password" class="swal2-input" placeholder="Password">`,
    confirmButtonText: 'Sign in',
    focusConfirm: false,
    preConfirm: (k) => {
      const login = Swal.getPopup().querySelector('#login').value
      const password = Swal.getPopup().querySelector('#password').value
      if (!login || !password) {
        Swal.showValidationMessage(`Please enter login and password`)
      }
      return { login: login, password: password }
    }
  }).then((result) => {
    Swal.fire(`
    Login: ${result.value.login}
    Password: ${result.value.password}
  `.trim())
  })

}


function qteOpen() {

  Swal.fire({
    title: 'Enter the amount',
    html: '<input value="0" id="duetChange"  min="-999999" step="1" unit="€" />',
    didOpen: () => {
      const input = Swal.getContainer().querySelector('#duetChange');
      input.addEventListener('keyup', (e) => {
        console.log("===d=d")
        //Swal.fire(`Entered amount`)
        var login = Swal.getPopup().querySelector('#duetChange').value
        Swal.showValidationMessage('Please enter a positive ' + login)
        const value = e.detail.value
        Swal.getConfirmButton().disabled = value < 0
      })
    },
    preConfirm: () => {
      const value = Swal.getContainer().querySelector('input').value
      return value < 0 ? Swal.showValidationMessage('Please enter a positive value') : value
    },
  }).then(function (result) {
    Swal.fire(`Entered amount: ${result.value}`)
  })


}



function openMobile(url, id, p, l, t, d, qmin, qmax) {
  var txt = "coool";
  var isQ = ((typeof iasQState !== 'undefined' && iasQState) || (typeof iasQState2 !== 'undefined' && iasQState2));
  var openFn = isQ ? OpenArticleq : OpenArticle;
  var viewPrefix = isQ ? 'Q' : 'A';
  Swal.fire({
    title: `<div class="pt-3 text-center"> ${sanctificationDec(l)} <br /></div>`,
    html: `<div class="pt-3 text-center"> ${sanctificationDec(d)} <br /> <br /> Prix : ${moneyFormat(t)} </div>`,
    showDenyButton: true,
    showCancelButton: false,
    showCloseButton: true,
    confirmButtonText: `<i class="fa-solid fa-cart-plus"></i> ` + localVars[1],
    denyButtonText: "Voir",
    customClass: {
      actions: 'my-actions',
      //cancelButton: 'order-1 right-gap',
      confirmButton: 'order-2',
      denyButton: 'order-3',
    }
  }).then((result) => {
    if (result.isConfirmed) {
      openFn(url, id, p, l, t, qmin, qmax, "js");
    } else if (result.isDenied) {
      // seeItem(url,id,p,l,t,d);
      //qteOpen();
      window.location.href = app_url + viewPrefix + '/' + id + '/' + urldecodeSanitaire(sanctificationDec(l));
    }
  })

}

function setLocalVars(id, val) {
  sessionStorage.setItem(id, val);
}

function getLocalVars(id) {
  var x = sessionStorage.getItem(id);
  return x;
  //document.getElementById("demo").innerHTML = x;
}

function dec(v) {
  p3x952 = v;
  return CryptoJS.AES.decrypt(v, "Secret Passphrase").toString(CryptoJS.enc.Utf8);
}

function enc(v) {
  p3x952 = v;
  //console.log("===========>>>>>"+p3x952);
  return CryptoJS.AES.encrypt(v, "Secret Passphrase");
}



function getVars() {
  return p3x952;
}

function checkEncKeyReq(key, variable) {

  return true;
}




function refeshPage() {
  if (panier_liste) {
    window.location.replace(panierPage);
  }
  else {

  }

}

function urldecodeSanitaireUpp(txt) {
  var txtT = "";
  //txt.innerHTML = txt;
  txtT = txt.replace(/("|')/g, '-');
  txtT = txt.replace(/("|eacute)/g, '-');
  txtT = txtT.replace(/\s+/g, '-');
  newStr = txtT.replace('&#039;', '-');
  //txtT = txtT.replace('&agrave;', 'a');
  //txtT = txtT.replace('&acirc;', 'a');
  //txtT = txtT.replace('&egrave;', 'e');
  //newStr = txtT.replace('&eacute;', 'e');

  newStr = newStr.replace(/(&#x40|@|@|&commat;|&#x41|A|A|&#x61|a|&#xC0|À|À|&Agrave;|&#xC1|Á|Á|&Aacute;|&#xC2|Â|Â|&Acirc;|&#xC3|Ã|Ã|&Atilde;|&#xC4|Ä|Ä|&Auml;|&#xC5|Å|Å|&Aring;|&#xE0|à|à|&agrave;|&#xE1|á|á|&aacute;|&#xE2|â|â|&acirc;|&#xE3|ã|ã|&atilde;|&#xE4|ä|ä|&auml;|&#xE5|å|å|&aring;)/gi, 'a');
  newStr = newStr.replace(/(&#xC7|Ç|Ç|&Ccedil;|&#xE7|ç|ç|&ccedil;)/gi, 'c');
  newStr = newStr.replace(/(&#xD0|Ð|Ð|&ETH;)/gi, 'd');
  newStr = newStr.replace(/(&#x45;|E|E|&#x65;|e|&#xC8;|È|È|&Egrave;|&#xC9;|É|É|&Eacute;|&#xCA;|Ê|Ê|&Ecirc;|&#xCB;|Ë|Ë|&Euml;|&#xE8;|è|è|&egrave;|&#xE9;|é|é|&eacute;|&#xEA;|ê|ê|&ecirc;|&#xEB;|ë|ë|&euml;)/gi, 'e');
  newStr = newStr.replace(/(&#x49|I|I|&#x69|i|&#xCC|Ì|Ì|&Igrave;|&#xCD|Í|Í|&Iacute;|&#xCE|Î|Î|&Icirc;|&#xCF|Ï|Ï|&Iuml;|&#xEC|ì|ì|&igrave;|&#xED|í|í|&iacute;|&#xEE|î|î|&icirc;|&#xEF|ï|ï|&iuml;)/gi, 'i');
  newStr = newStr.replace(/(&#x4E|N|N|&#x6E|n|&#xD1|Ñ|Ñ|&Ntilde;|&#xF1|ñ|ñ|&ntilde;)/gi, 'n');
  newStr = newStr.replace(/(&#x4F|O|O|&#x6F|o|&#xD2|Ò|Ò|&Ograve;|&#xD3|Ó|Ó|&Oacute;|&#xD4|Ô|Ô|&Ocirc;|&#xD5|Õ|Õ|&Otilde;|&#xD6|Ö|Ö|&Ouml;|&#xF2|ò|ò|&ograve;|&#xF3|ó|ó|&oacute;|&#xF4|ô|ô|&ocirc;|&#xF5|õ|õ|&otilde;|&#xF6|ö|ö|&ouml;|&#xF8|ø|ø|&oslash;)/gi, 'o');
  newStr = newStr.replace(/(&#x55|U|U|&#x75|u|&#xD9|Ù|Ù|&Ugrave;|&#xDA|Ú|Ú|&Uacute;|&#xDB|Û|Û|&Ucirc;|&#xDC|Ü|Ü|&Uuml;|&#xF9|ù|ù|&ugrave;|&#xFA|ú|ú|&uacute;|&#xFB|û|û|&ucirc;|&#xFC|ü|ü|&uuml;)/gi, 'u');
  newStr = newStr.replace(/(&#x59|Y|Y|&#x79|y|&#xDD|Ý|Ý|&Yacute;|&#xFD|ý|ý|&yacute;|&#xFF|ÿ|ÿ|&yuml;)/gi, 'y');
  newStr = newStr.replace(/(&#xC6|Æ|Æ|&AElig;|&#xE6|æ|æ|&aelig;)/gi, 'ae');
  newStr = newStr.replace(/(&#x8C|Œ|Œ|&OElig;|&#x9C|œ|œ|&oelig;)/gi, 'oe');

  return newStr.toLowerCase();
}


function urldecodeSanitaire(txt) {
  var txte = null;
  //console.log(txt+" ======  ORN ======= ");
  var newStr;
  //if(isset(txt))
  if (isset(txt)) {
    newStr = txt.trim();
    newStr = newStr.replace(/(&#x40|@|@|&commat;|&#x41|A|A|&#x61|a|&#xC0|À|À|&Agrave;|&#xC1|Á|Á|&Aacute;|&#xC2|Â|Â|&Acirc;|&#xC3|Ã|Ã|&Atilde;|&#xC4|Ä|Ä|&Auml;|&#xC5|Å|Å|&Aring;|&#xE0|à|à|&agrave;|&#xE1|á|á|&aacute;|&#xE2|â|â|&acirc;|&#xE3|ã|ã|&atilde;|&#xE4|ä|ä|&auml;|&#xE5|å|å|&aring;)/g, 'a');
    newStr = newStr.replace(/(&#xC7|Ç|Ç|&Ccedil;|&#xE7|ç|ç|&ccedil;)/g, 'c');
    newStr = newStr.replace(/(&#xD0|Ð|Ð|&ETH;)/g, 'd');
    newStr = newStr.replace(/(&#x45;|E|E|&#x65;|e|&#xC8;|È|È|&Egrave;|&#xC9;|É|É|&Eacute;|&#xCA;|Ê|Ê|&Ecirc;|&#xCB;|Ë|Ë|&Euml;|&#xE8;|è|è|&egrave;|&#xE9;|é|é|&eacute;|&#xEA;|ê|ê|&ecirc;|&#xEB;|ë|ë|&euml;)/g, 'e');
    newStr = newStr.replace(/(&#x49|I|I|&#x69|i|&#xCC|Ì|Ì|&Igrave;|&#xCD|Í|Í|&Iacute;|&#xCE|Î|Î|&Icirc;|&#xCF|Ï|Ï|&Iuml;|&#xEC|ì|ì|&igrave;|&#xED|í|í|&iacute;|&#xEE|î|î|&icirc;|&#xEF|ï|ï|&iuml;)/g, 'i');
    newStr = newStr.replace(/(&#x4E|N|N|&#x6E|n|&#xD1|Ñ|Ñ|&Ntilde;|&#xF1|ñ|ñ|&ntilde;)/g, 'n');
    newStr = newStr.replace(/(&#x4F|O|O|&#x6F|o|&#xD2|Ò|Ò|&Ograve;|&#xD3|Ó|Ó|&Oacute;|&#xD4|Ô|Ô|&Ocirc;|&#xD5|Õ|Õ|&Otilde;|&#xD6|Ö|Ö|&Ouml;|&#xF2|ò|ò|&ograve;|&#xF3|ó|ó|&oacute;|&#xF4|ô|ô|&ocirc;|&#xF5|õ|õ|&otilde;|&#xF6|ö|ö|&ouml;|&#xF8|ø|ø|&oslash;)/g, 'o');
    newStr = newStr.replace(/(&#x55|U|U|&#x75|u|&#xD9|Ù|Ù|&Ugrave;|&#xDA|Ú|Ú|&Uacute;|&#xDB|Û|Û|&Ucirc;|&#xDC|Ü|Ü|&Uuml;|&#xF9|ù|ù|&ugrave;|&#xFA|ú|ú|&uacute;|&#xFB|û|û|&ucirc;|&#xFC|ü|ü|&uuml;)/g, 'u');
    newStr = newStr.replace(/(&#x59|Y|Y|&#x79|y|&#xDD|Ý|Ý|&Yacute;|&#xFD|ý|ý|&yacute;|&#xFF|ÿ|ÿ|&yuml;)/g, 'y');
    newStr = newStr.replace(/(&#xC6|Æ|Æ|&AElig;|&#xE6|æ|æ|&aelig;)/g, 'ae');
    newStr = newStr.replace(/(&#x8C|Œ|Œ|&OElig;|&#x9C|œ|œ|&oelig;)/g, 'oe');
  }
  else {
    newStr = " XXX";
  }




  return sanctification(newStr.toLowerCase());
}



function StringNotNull(txt) {
  var txtFinal = "";
  if (isset(txt)) {
    txtFinal = txt;
  } else {
    txtFinal = "";
  }


  return txtFinal;
}







async function searchEngineM() {
  var key = token_api_client;
  var show_suggest = document.getElementById("show_suggestM");
  var searchTypeId = document.querySelector("#searchTypeM");
  var searchType = searchTypeId.options[searchTypeId.selectedIndex].getAttribute('value');

  if (show_suggest) {
    var searchTxt = show_suggest.value;
    if (searchTxt.length == 0) {
      let fatherI = document.getElementById("search_result_shadowM");
      fatherI.innerHTML = "";
      return false;
    }
    //console.log(" Search Mobile "+show_suggest.value+" "+searchType); 
    fetch(app_url + `ajax/client/api.php?req=5&token_api_client=${key}&searchTxt=${searchTxt}&searchType=${searchType}&browser=m`)
      .then((response) => {
        if (!response.ok) { // Before parsing (i.e. decoding) the JSON data,
          // check for any errors.
          // In case of an error, throw.
          throw new Error("Something went wrong!");
        }

        return response.json(); // Parse the JSON data.
      })
      .then((data) => {
        // This is where you handle what to do with the response.
        //alert(data); // Will alert: 42
        //let father = document.createDocumentFragment();
        let father = document.getElementById("search_result_shadowM");
        father.innerHTML = "";


        console.log(data.length);
        console.log(data.length);
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            console.log(" NBR " + i);
            let donnee = data[i];
            console.log(data[i]);

            let item = createSearchResultM(donnee, localVars, searchType);


            father.appendChild(item);

          }
        }
        else {
          let item = createSearchResultVoid("", localVars);

          father.appendChild(item);
        }
        ///////
      })
      .catch((error) => {
        errorPage();    // This is where you handle errors.
      });
  }

}





async function searchEngine() {
  var key = token_api_client;
  var show_suggest = document.getElementById("show_suggest");
  var searchTypeId = document.querySelector("#searchType");
  var searchType = searchTypeId.options[searchTypeId.selectedIndex].getAttribute('value');

  if (show_suggest) {
    var searchTxt = show_suggest.value;
    if (searchTxt.length == 0) {
      let fatherI = document.getElementById("search_result_shadow");
      fatherI.innerHTML = "";
      return false;
    }
    console.log(" Search  " + show_suggest.value + " " + searchType);
    fetch(app_url + `ajax/client/api.php?req=5&token_api_client=${key}&searchTxt=${searchTxt}&searchType=${searchType}&browser=w`)
      .then((response) => {
        if (!response.ok) { // Before parsing (i.e. decoding) the JSON data,
          // check for any errors.
          // In case of an error, throw.
          throw new Error("Something went wrong!");
        }

        return response.json(); // Parse the JSON data.
      })
      .then((data) => {
        // This is where you handle what to do with the response.
        //alert(data); // Will alert: 42
        //let father = document.createDocumentFragment();
        let father = document.getElementById("search_result_shadow");
        father.innerHTML = "";


        console.log(data.length);
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            console.log(" NBR " + i);
            let donnee = data[i];
            console.log(data[i]);

            let item = createSearchResult(donnee, localVars, searchType);


            father.appendChild(item);

          }
        }
        else {

          let item = createSearchResultVoid("", localVars);

          father.appendChild(item);
        }
        ///////
      })
      .catch((error) => {
        errorPage();    // This is where you handle errors.
      });
  }

}

function createSearchResultVoid(id, localVars) {
  //let li = document.createElement('p');

  const textContent = ` <a href="#" class="single_sresult_product">
                                <div class="sresult_img">
                                  <img loading="lazy"  src="${app_url}article/panier.jpg" alt="product">   
                                </div>
                                <div class="sresult_content">
                                    <h4>${localVars[7]}</h4>
                                    <div class="price">
                                        <span class="org_price"></span>
                                    </div>
                                </div>
                            </a>`;

  let item = document.createElement('div');
  //const listeBase = document.getElementById("search_result_shadow");
  //listeBase.classList.add("row");
  item.innerHTML = textContent.trim();


  return item.firstChild;
}

function createSearchResult(id, qte, gr) {
  //let li = document.createElement('p');
  var l = id.l;
  var i = id.i;
  var p = id.p;
  var t = id.t;
  var gr_txt = "";
  var gr_repo = "";
  if (gr == 0)// Article
  {
    gr_txt = "A";
    gr_repo = "article";
  }

  if (gr == 1)// imm location
  {
    gr_txt = "M";
    gr_repo = "immobilier";
  }

  if (gr == 2)// imm vente
  {
    gr_txt = "M";
    gr_repo = "immobilier";
  }

  if (gr == 3)// terrain
  {
    gr_txt = "T";
    gr_repo = "terrain";
  }

  if (gr == 4)// quincaillerie
  {
    gr_txt = "Q";
    gr_repo = "quincaillerie";
  }

  if (p.length > 0) {
    var imgSrcSearch = app_url + gr_repo + '/' + p;
  }
  else {
    var imgSrcSearch = app_img_url + 'noimgxl.jpg';
  }

  const textContent = ` <a href="${app_url + gr_txt + '/' + i + '/' + urldecodeSanitaire(l)}" class="single_sresult_product">
                                <div class="sresult_img">
                                    <img loading="lazy"  src="${imgSrcSearch}" alt="product">
                                </div>
                                <div class="sresult_content">
                                    <h4>${l}</h4>
                                    <div class="price">
                                        <span class="org_price">${moneyFormat(t)}</span>
                                    </div>
                                </div>
                            </a>`;

  let item = document.createElement('div');
  //const listeBase = document.getElementById("search_result_shadow");
  //listeBase.classList.add("row");
  item.innerHTML = textContent.trim();


  return item.firstChild;
}

function createSearchResultM(id, qte, gr) {
  //let li = document.createElement('p');
  var l = id.l;
  var i = id.i;
  var p = id.p;
  var t = id.t;
  var gr_txt = "";
  var gr_repo = "";

  /////
  if (gr == 0)// Article
  {
    gr_txt = "A";
    gr_repo = "article";
  }

  if (gr == 1)// imm location
  {
    gr_txt = "M";
    gr_repo = "immobilier";
  }

  if (gr == 2)// imm vente
  {
    gr_txt = "M";
    gr_repo = "immobilier";
  }

  if (gr == 3)// terrain
  {
    gr_txt = "T";
    gr_repo = "terrain";
  }

  //////
  if (gr == 4)// quincaillerie
  {
    gr_txt = "Q";
    gr_repo = "quincaillerie";
  }

  //////
  if (p.length > 0) {
    var imgSrcSearch = app_url + gr_repo + '/' + p;
  }
  else {
    var imgSrcSearch = app_img_url + 'noimgxl.jpg';
  }

  console.log("=========   SEARCH MOBILE   IN  ===== ");
  const textContent = ` <a href="${app_url + gr_txt + '/' + i + '/' + urldecodeSanitaire(l)}" class="single_sresult_product">
                                <div class="sresult_img">
                                    <img loading="lazy"  src="${imgSrcSearch}" alt="product">
                                </div>
                                <div class="sresult_content">
                                    <h4>${l}</h4>
                                    <div class="price">
                                        <span class="org_price">${moneyFormat(t)}</span>
                                        <span class="prev_price">${moneyFormat(t * 1.2)}</span>
                                    </div>
                                </div>
                            </a>`;

  let item = document.createElement('div');
  //const listeBase = document.getElementById("search_result_shadow");
  //listeBase.classList.add("row");
  item.innerHTML = textContent.trim();


  return item.firstChild;
}


function nbrPremier(nbr) {
  for (var i = 2; i < nbr; i++)
    if (nbr % i === 0) return false;
  return nbr > 1;
}

function isPrime(num) {
  if (num <= 1) return false; if (num === 2) return true; let numSqrt = Math.sqrt(num); for (let i = 2; i <= numSqrt; i++) { if (num % i === 0) return false; } return true;
}



function CheckDiviseur(nbr, Nbrlist) {
  var NewList = [];
  var NbrFinal = 0;
  for (var i = 1; i < Nbrlist.length; i++) {

    let result = parseInt(nbr) / parseInt(Nbrlist[i]);
    //console.log(result+" I :  === "+nbr+"/"+Nbrlist[i]+"==== i"+i); 
    if (Number.isInteger(result)) {
      const count = NewList.push(Nbrlist[i]);
    }
    else {

    }
  }
  //console.log("=== LIST : "+NewList);
  return Math.max(...NewList);
}



function MyPGCD(nbr) {
  var nbr_final = 0;
  var diviseur = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  if (diviseur.includes(nbr)) {
    nbr_final = nbr;
  }
  else {
    if (isPrime(nbr)) {
      nbr_final = nbr;
    }
    else {
      nbr_final = CheckDiviseur(nbr, diviseur);
    }

  }




  return nbr_final;

}

function NotShowNull(pre, txt) {
  var texte;
  //var length = txt.length;
  //console.log(txt);
  if (txt == "null" || txt == "" || txt == undefined) {
    texte = "";
  }
  else {
    texte = pre + txt;
  }
  return texte;
}

function NiceSubstr(nbr, txt) {
  var texte;
  if (txt.length > nbr) {
    texte = txt.substring(0, nbr - 3) + "...";
  }
  else {
    texte = txt;
  }

  return texte;
}

function isset() {
  // http://kevin.vanzonneveld.net
  // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +   improved by: FremyCompany
  // +   improved by: Onno Marsman
  // *     example 1: isset( undefined, true);
  // *     returns 1: false
  // *     example 2: isset( 'Kevin van Zonneveld' );
  // *     returns 2: true

  var a = arguments; var l = a.length; var i = 0;

  if (l == 0) {
    throw new Error('Empty isset');
  }

  while (i != l) {
    if (typeof (a[i]) == 'undefined' || a[i] === null) {
      return false;
    } else {
      i++;
    }
  }
  return true;
}


///////////////
async function fetchMovies404() {
  //const response = await fetch('/oops');

  //response.ok;     // => false
  //response.status; // => 404

  //const text = await response.text();
  //return text;
}

fetchMovies404().then(text => {
  // text; // => 'Page not found'
});
////////////////////////////////////////////////////////////////////////////
function shareObjet(titre, texte, adresse) {
  let shareData = {
    title: titre,
    text: texte,
    url: adresse,
  }

  const btn = document.querySelector('#share');
  const resultPara = document.querySelector('#result');

  // btn.addEventListener('click', () => {
  navigator.share(shareData)
    .then(() =>
      //resultPara.textContent = 'MDN shared successfully'
      console.log("shared successfully")
    )
    .catch((e) =>
      //resultPara.textContent = 'Error: ' + e
      console.warn('Error: ' + e)
    )
  //});


}

function sanctification(txt) {

  txtT = txt.replace(/("|<br \/>|'|`|&#039;|&#043;|&quot;| )/g, '-');
  txtT = txtT.replace(/\//g, '-');



  return txtT;

}

function sanctificationLITE(txt) {
  //console.log(txt);
  var txtT = "";
  $htmltagsregex = '/\<(.*)?\>/';
  txtT = txt.replace(/("|'|`|&#039;|&#043;|&quot;| )/g, ' ');
  txtT = txtT.replace(/\//g, '');
  txtT = txtT.replace(/<br\s*\/?>/gi, ' ')
  txtT = txtT.replace(/(?:\r\n|\r|\n)/g, "");
  txtT = txtT.replace($htmltagsregex, ' ');



  return txtT;

}

function sanctificationLITEenc(txt) {
  //console.log(txt);
  var txtT = "";
  $htmltagsregex = '/\<(.*)?\>/';
  txtT = txt.replace(/("|'|`|&#039;|&#043;|&quot;| )/g, ' ');
  txtT = txtT.replace(/<br\s*\/?>/gi, '[BR]')
  txtT = txtT.replace(/(?:\r\n|\r|\n)/g, "");
  txtT = txtT.replace(/\//g, '');
  txtT = txtT.replace($htmltagsregex, ' ');



  return txtT;

}


function sanctificationLITEdec(txt) {
  // console.log(txt);
  var txtT = "";
  txtT = txt.replace(/\[BR\]/gi, '<BR/>');



  return txtT;

}



function MySubstring(text, nbr) {
  var textfinal = "";
  if (text.length > nbr) {


    textfinal = text;
    //textfinal = textfinal.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
    //textfinal = textfinal.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');

    textfinal = textfinal.substr(0, nbr) + "...".replace(/"/g, '&quot;');
    //textfinal = textfinal.substr(0,nbr)+"".replace(/"/g, '&quot;');
    //let position = textfinal.search("&laq...");
    //textfinal = textfinal.split('##')[0];
    textfinal = textfinal.replace("&laqu...", '...');
    textfinal = textfinal.replace("&laq...", '...');
    textfinal = textfinal.replace("&la...", '...');
    textfinal = textfinal.replace("&l...", '...');
    textfinal = textfinal.replace("&...", '...');

    textfinal = textfinal;
    //console.log(textfinal+"====== TXT L"+text.length+"=="+position);   
  }
  else {
    textfinal = text.replace(/"/g, '&quot;');

  }
  return textfinal;

}

function sanctificationEnc(txt) {

  txtT = txt.replace(/(`)/g, '#@46;');
  txtT = txtT.replace(/\n|<br\s*\/?>/gi, "\r")
  txtT = txtT.replace(/(')/g, '#@45;');
  txtT = txtT.replace(/&#039;/g, "#@45;");

  txtT = txtT.replace(/(")/g, "#@44;");
  txtT = txtT.replace(/&quot;/g, "#@44;");
  txtT = txtT.replace(/(<([^>]+)>)/gi, "");
  txtT = txtT.replace(/\//g, "#@43;");
  txtT = txtT.replace(/\</g, "#@42;");
  txtT = txtT.replace(/\>/g, "#@41;");
  txtT = txtT.replace(/\«/g, "#@40;");
  //replace(/[^\w\s]/gi, '')
  // &hellip; 
  // &laquo;
  // &#039;



  return txtT;

}

function sanctificationDec(txt) {

  txtT = txt.replace(/(#@46;)/g, '`');
  txtT = txtT.replace(/(#@45;)/g, "'");
  txtT = txtT.replace(/(#@44;)/g, '"');
  txtT = txtT.replace(/(#@43;)/g, '/');
  txtT = txtT.replace(/(#@40;)/g, '«');


  return txtT;

}


function trimSP(str) {
  return str.replace(/^\s+|\s+$/g, '-');
}

function errorPage() {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'vérifiez votre connexion internet !',
    footer: '<a href="">Vous n\'avez plus la connexion internet</a>'
  })
}

function infoBox(icon, title, text, footer) {
  Swal.fire({
    icon: icon,
    title: title,
    text: text,
    footer: footer
  })
}






$('.slider').slick({
  centerMode: true,
  centerPadding: '60px',
  prevArrow: '',
  nextArrow: '',
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 380,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    }
  ]
});








